export const paymentWeekOptions = [
    { value: '1', name: '1. HAFTA' },
    { value: '2', name: '2. HAFTA' },
    { value: '3', name: '3. HAFTA' },
    { value: '4', name: '4. HAFTA' },
]

export const currenciesOptions = [
    { value: 'N', name: 'TL' },
    { value: 'U', name: 'USD' },
    { value: 'E', name: 'EURO' },
    { value: 'Z', name: 'USD/EUR' },
]

export const yesNoOptions = [{ value: '1', name: 'Evet' }, { value: '0', name: 'Hayır' }]

export const overseasConnectionYesNoOptions = [{ value: 'E', name: 'Evet' }, { value: 'H', name: 'Hayır' }]

export const onlineShoppingOptions = [{ value: '1', name: 'AÇIK' }, { value: '0', name: 'KAPALI' }]

export const kinshipOptions = [
    { value: 'E', name: 'EŞ' },
    { value: 'C', name: 'ÇOCUK' },
    { value: 'A', name: 'AKRABA' },
    { value: 'R', name: 'ARKADAŞ' },
    { value: 'D', name: 'DİĞER' },
]

export const additionalCardLimitRateOptions = [
    { value: '25', name: '%25' },
    { value: '50', name: '%50' },
    { value: '75', name: '%75' },
    { value: '100', name: '%100' },
]

export const AddressType = {
    WORK: "work",
    HOME: "home"
}

export const ON_RED_RESULT = {
    ONAY: "ONAY",
    RET: "RET",
};

export const OccupationAndAddressConstants = {
    CAN_RESUME_WITH_EXISTING_INFO_STATE: "canResumeWithExistingInfoState",
    EXIST_INFO: "existInfo",
    NEW_INFO: "newInfo",
    OLD: "Old",
    NEW: "New",
    ADDRESS_TYPE: "addressType",
    IS_WORK_ADDRESS_SHOW: "isWorkAddressShow",
    HOMER_OR_OFFICE_ADDRESS_TYPE_TYPE: "homeOrOfficeAddressType",
    HOME: "Home",
    OFFICE: "Office",
    SELECTED_EDUCATION_STATUS: "selectedEdeducationStatus",
    IS_COLLAGE_STUDENT: "isCollageStudent",
    OGRENIM_DURUMU_EGITIMSIZ_VALUE: "0",
    OGRENIM_DURUMU_EGITIMSIZ_LABEL: "EĞİTİMSİZ",
    MESLEK_OGRENCI: "ÖĞRENCİ",
    CALISMA_SEKLI_OGRENCI: "6",
    ON_LISANS: 4,
    UNIVERSITE: 5,
    YUKSEK_LISANS: 6,
    DOKTORA: 9,
    EMEKLI: 4,
    EV_HANIMI: 5,
    OGRENCI: 6
}

export const DefaultObjectType = { value: "", label: "" }

export const DefaultAddressType = {
    work: { workPlaceName: "", city: DefaultObjectType, town: DefaultObjectType, district: DefaultObjectType, freeFormatAddress: "" },
    home: { workPlaceName: "", city: DefaultObjectType, town: DefaultObjectType, district: DefaultObjectType, freeFormatAddress: "" }
}

export const BUSINESS_CLOSEST_BRANCHES_SERVICE_BRANCH_TYPES = "1,7"

export const WINGS = "wings"
export const AXESS = "axess"
export const YES = "YES"
export const NO = "NO"

export const CARD_CODE_AXESS_OGRENCI_DIGITAL = "23"
export const CARD_CODE_AXESS_OGRENCI = "20"
export const CARD_CODE_AXESS_DIGITAL = "13"
export const CARD_CODE_AXESS = "10"
export const CARD_CODE_WINGS_DIGITAL = "33"
export const CARD_CODE_WINGS = "30"

export const GUVENLIK_SORGULA_MAPPED_LIST = [
    "COR-30477",
    "COR-30482",
    "COR-30483",
    "COR-41496",
    "CCM_0046"
]

export const GENERIC_ERROR_CODES = {
    TCKN_KPS_KAYDI_YOK: "COR-50534",
    TCKN_APS_KAYIT_BULUNAMADI: "COR-68227",
    MBB_CONTROL_ERROR_INVITE_TO_BRANCH: "COR-30477",
    MBB_AST_DOGRULANAMADI: "COR-30482",
    MBB_MUSTERI_TIPI_HATALI: "COR-30483",
    EV_IS_TELEFONU_ALAN_KODU_HATALI: "COR-50526",
    GUVENLI_TELEFONU_BULUNAMADI: "COR-30481",
    TELEFON_BASKA_MUSTERIDE_AST_OLARAK_TANIMLI: "COR-30484",
    ESKI_NUFUS_CUZDANI_INVITE_TO_BRANCH: "InviteToBranch",
}
